import { useEffect } from 'react';
import { Flex, Loader } from '@mantine/core';
import useTemplates from 'src/data-capture/hooks/templates/useTemplates';
import { TemplateList } from '../edit/components/TemplateList';
import { StepProps } from '../types';
import { StepCard } from 'src/UI/generate-flow/StepCard';

export function TemplateStep({ data, setData }: StepProps) {
  const { files, isLoading } = useTemplates({ templateType: 'SUITABILITY_REPORT' });

  useEffect(() => {
    if (!data.template && files.length > 0) {
      const defaultTemplate = files.find(t => t.isDefault);
      if (defaultTemplate) {
        setData(prev => ({ ...prev, template: defaultTemplate }));
      }
    }
  }, [files, data.template, setData]);

  return (
    <Flex direction="column" h="100%" mih={0} gap="md">
      <StepCard title="Please select the template report based on the advice being given">
        <Flex direction="column" gap="xs" mih={0}>
          {isLoading ? (
            <Flex justify="center" align="center" h="100%">
              <Loader data-testid="loader" />
            </Flex>
          ) : (
            <TemplateList
              items={files}
              selectedTemplateId={data.template?.id}
              onSelect={template => setData(prev => ({ ...prev, template }))}
            />
          )}
        </Flex>
      </StepCard>
    </Flex>
  );
}
